const countryCodeMap = {"AF": "Afghanistan","AL": "Albania","DZ": "Algeria","AD": "Andorra","AO": "Angola","AG": "Antigua and Barbuda","AR": "Argentina","AM": "Armenia","AU": "Australia","AT": "Austria","AZ": "Azerbaijan","BS": "Bahamas","BH": "Bahrain","BD": "Bangladesh","BB": "Barbados","BY": "Belarus","BE": "Belgium","BZ": "Belize","BJ": "Benin","BT": "Bhutan","BO": "Bolivia","BA": "Bosnia and Herzegovina","BW": "Botswana","BR": "Brazil","BN": "Brunei","BG": "Bulgaria","BF": "Burkina Faso","BI": "Burundi","KH": "Cambodia","CM": "Cameroon","CA": "Canada","CV": "Cape Verde","CF": "Central African Republic","TD": "Chad","CL": "Chile","CN": "China","CO": "Colombia","KM": "Comoros","CG": "Congo","CR": "Costa Rica","CI": "Cote d'Ivoire","HR": "Croatia","CU": "Cuba","CY": "Cyprus","CZ": "Czech Republic","DK": "Denmark","DJ": "Djibouti","DM": "Dominica","DO": "Dominican Republic","EC": "Ecuador","EG": "Egypt","SV": "El Salvador","GQ": "Equatorial Guinea","ER": "Eritrea","EE": "Estonia","ET": "Ethiopia","FJ": "Fiji","FI": "Finland","FR": "France","GA": "Gabon","GM": "Gambia","GE": "Georgia","DE": "Germany","GH": "Ghana","GR": "Greece","GD": "Grenada","GT": "Guatemala","GN": "Guinea","GW": "Guinea-Bissau","GY": "Guyana","HT": "Haiti","HN": "Honduras","HU": "Hungary","IS": "Iceland","IN": "India","ID": "Indonesia","IR": "Iran","IQ": "Iraq","IE": "Ireland","IL": "Israel","IT": "Italy","JM": "Jamaica","JP": "Japan","JO": "Jordan","KZ": "Kazakhstan","KE": "Kenya","KI": "Kiribati","KP": "North Korea","KR": "South Korea","KW": "Kuwait","KG": "Kyrgyzstan","LA": "Laos","LV": "Latvia","LB": "Lebanon","LS": "Lesotho","LR": "Liberia","LY": "Libya","LI": "Liechtenstein","LT": "Lithuania","LU": "Luxembourg","MK": "North Macedonia","MG": "Madagascar","MW": "Malawi","MY": "Malaysia","MV": "Maldives","ML": "Mali","MT": "Malta","MH": "Marshall Islands","MR": "Mauritania","MU": "Mauritius","MX": "Mexico","FM": "Micronesia","MD": "Moldova","MC": "Monaco","MN": "Mongolia","ME": "Montenegro","MA": "Morocco","MZ": "Mozambique","MM": "Myanmar","NA": "Namibia","NR": "Nauru","NP": "Nepal","NL": "Netherlands","NZ": "New Zealand","NI": "Nicaragua","NE": "Niger","NG": "Nigeria","NO": "Norway","OM": "Oman","PK": "Pakistan","PW": "Palau","PA": "Panama","PG": "Papua New Guinea","PY": "Paraguay","PE": "Peru","PH": "Philippines","PL": "Poland","PT": "Portugal","QA": "Qatar","RO": "Romania","RU": "Russia","RW": "Rwanda","KN": "Saint Kitts and Nevis","LC": "Saint Lucia","VC": "Saint Vincent and the Grenadines","WS": "Samoa","SM": "San Marino","ST": "Sao Tome and Principe","SA": "Saudi Arabia","SN": "Senegal","RS": "Serbia","SC": "Seychelles","SL": "Sierra Leone","SG": "Singapore","SK": "Slovakia","SI": "Slovenia","SB": "Solomon Islands","SO": "Somalia","ZA": "South Africa","SS": "South Sudan","ES": "Spain","LK": "Sri Lanka","SD": "Sudan","SR": "Suriname","SE": "Sweden","CH": "Switzerland","SY": "Syria","TW": "Taiwan","TJ": "Tajikistan","TZ": "Tanzania","TH": "Thailand","TL": "Timor-Leste","TG": "Togo","TO": "Tonga","TT": "Trinidad and Tobago","TN": "Tunisia","TR": "Turkey","TM": "Turkmenistan","TV": "Tuvalu","UG": "Uganda","UA": "Ukraine","AE": "United Arab Emirates (UAE)","GB": "United Kingdom (UK)","US": "United States","UY": "Uruguay","UZ": "Uzbekistan","VU": "Vanuatu","VA": "Vatican City (Holy See)","VE": "Venezuela","VN": "Vietnam","YE": "Yemen","ZM": "Zambia","ZW": "Zimbabw"}

async function getBrowserLoc() {
  const response = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
  const text = await response.text();
  const lines = text.split('\n');
  const locLine = lines.find(line => line.startsWith('loc='));
  const loc = locLine.substring(4);
  return loc
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

Date.prototype.format = function (formatStr) {
  var date = this;
  var zeroize = function (value, length) {
      if (!length) {
          length = 2;
      }
      value = new String(value);
      for (var i = 0, zeros = ''; i < (length - value.length); i++) {
          zeros += '0';
      }
      return zeros + value;
  };
  return formatStr.replace(/"[^"]*"|'[^']*'|\b(?:d{1,4}|M{1,4}|yy(?:yy)?|([hHmstT])\1?|[lLZ])\b/g, function ($0) {
      switch ($0) {
          case 'd': return date.getDate();
          case 'dd': return zeroize(date.getDate());
          case 'ddd': return ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat'][date.getDay()];
          case 'dddd': return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()];
          case 'M': return date.getMonth() + 1;
          case 'MM': return zeroize(date.getMonth() + 1);
          case 'MMM': return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][date.getMonth()];
          case 'MMMM': return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][date.getMonth()];
          case 'yy': return new String(date.getFullYear()).substr(2);
          case 'yyyy': return date.getFullYear();
          case 'h': return date.getHours() % 12 || 12;
          case 'hh': return zeroize(date.getHours() % 12 || 12);
          case 'H': return date.getHours();
          case 'HH': return zeroize(date.getHours());
          case 'm': return date.getMinutes();
          case 'mm': return zeroize(date.getMinutes());
          case 's': return date.getSeconds();
          case 'ss': return zeroize(date.getSeconds());
          case 'l': return date.getMilliseconds();
          case 'll': return zeroize(date.getMilliseconds());
          case 'tt': return date.getHours() < 12 ? 'am' : 'pm';
          case 'TT': return date.getHours() < 12 ? 'AM' : 'PM';
      }
  });
}


function getDate(addDayCount) {
  var d = new Date()
  d.setDate(d.getDate() + addDayCount)
  return d.format('MMM.d')
}

document.querySelectorAll('[countdown]').forEach((item) => {
  var endtime = item.dataset.endtime.replace(/-/g,"/")
  if (typeof endtime == 'string') {
    endtime = new Date(endtime)
  }
  endtime = new Date(endtime.getTime() + 12 * 3600 * 1000)
  
  countdown({
    id: item.dataset.id,
    endtime
  })
})

jqReady(function() {
  $('select.select__select').on('change', function() {
    var value = $(this).val()
    var trigger = $(this).closest('[data-swatch-option]').find('.select__trigger [data-swatch-item][data-value="' + value +'"]')
    if (trigger) {
      trigger.click()
    }
  })

  getBrowserLoc().then(function(loc) {

    var delivery = $('.delivery-time')
    var makingObj = delivery.data('making_time')
    var shippingObj = delivery.data('shipping_time')


    var tailoringTime = makingObj[loc] || makingObj['default']
    var shippingTime = shippingObj[loc] || shippingObj['default']

    $('#make_time').text(tailoringTime)
    $('#shipping_time').text(shippingTime)

    var tailoringRange = tailoringTime.split('-')
    var shippingRange = shippingTime.split('-')

    var deliveryMin = parseInt(tailoringRange[0]) + parseInt(shippingRange[0])
    var deliveryMax = parseInt(tailoringRange[1]) + parseInt(shippingRange[1])

    $('.delivery-time #faq-delivery-time').html(`${getDate(deliveryMin)} - ${getDate(deliveryMax)}`)

    const countruName = countryCodeMap[loc] || 'Your Country'
    $('.ship-to-country-name').text(countruName)
    $('.delivery-time').show()
  })

  $('.bundle__item-detail select').change(function() {
    var variantId = $(this).val()
    var datas = $(this).find('option[value="'+ variantId +'"]').data()
    var priceNode = $(this).closest('.bundle__item-detail').find('.price-info')
    priceNode.find('.bundle__item-price').html(formatMoney(datas.price))
    priceNode.find('.bundle__item-compare_at_price').html(datas.compare_at_price > 0 ? formatMoney(datas.compare_at_price) : '')
    if (datas.img) {
      $(this).closest('.bundle__item').find('.bundle__item-image img').attr('src', datas.img)
    }
  })


  $('.bundle__item-action').click(function() {
    var that = this
    var variantId = $(this).closest('.bundle__item').find('select').val()
    var items = [{id: variantId, quantity: 1}];
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
    $(that).find('.bundle__item-text').text('ADDING ...')
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items, sections: sectionsToBundle.join(',') })
    })
    .then(response => {
      return response.json();
    })
    .then(async (responseJson) => {
      if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
        return window.location.href = `${Shopify.routes.root}cart`;
      }
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));

      $(that).find('.bundle__item-text').text('ADDED!')

      setTimeout(function() {
        $(that).find('.bundle__item-text').text('ADD')
      }, 1000)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  })

  $('.js-product-info__description').delegate('.action-btn', 'click', function() {
    var pNode = $(this).closest('.js-product-info__description')
    let btnText = pNode.hasClass('active') ? 'Show More' : 'Show Less'
    $(pNode).find('.action-btn').text(btnText)
    $(pNode).toggleClass('active')
   })



  $('.product__anchor-points').on('click', '.anchor-point', function (e) {
    e.preventDefault();

    const targetId = $(this).data('target');
    let topValue = $(targetId).offset().top;
    if (targetId =="#details-purchase") {
       topValue = 0;
    } 
    window.scrollTo({
      top: topValue,
      behavior: "smooth"
    });
  });

  $('.product__anchor-points a[data-target="#main-wapper"]').on('click', function(e) {
    e.preventDefault();
    window.scrollTo({
      top: $('#main-wapper').offset().top - 150,
      behavior: "smooth"
    });
  })

  function getElementTop(element){
    var actualTop = element.offsetTop;
    var current = element.offsetParent;

    while (current !== null){
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }

    return actualTop;
  }

  window.addEventListener('scroll', function() {
    const anchorPointsH = $('.product__anchor-points').height();
    if ($(document).height() <= (parseInt($(document).scrollTop() + 1) + $(window).height())) {
      return;
    }
    var offsetTop = $(document).scrollTop() + anchorPointsH;

    $('.product__anchor-points  a.anchor-point[data-target]').each((_, ele) => {
      const point_id = ele.dataset.target
      const targetNode = document.querySelector(point_id)

      if (getElementTop(targetNode) <= offsetTop) {
        $(".product__anchor-points .anchor-point").removeClass('active');
        ele.classList.add('active');
      }
    })
  })
  
  let scrollX,scrollY,scrollDirection;
    function getScrollAction() {
      if (typeof scrollX == 'undefined') {
        scrollX = window.pageXOffset;
        scrollY = window.pageYOffset;
        scrollDirection = 'down';
      }
      var diffX = scrollX - window.pageXOffset;
      var diffY = scrollY - window.pageYOffset;
  
      if (diffX < 0) {
        // Scroll right
        scrollDirection = 'right';
      } else if (diffX > 0) {
        // Scroll left
        scrollDirection = 'left';
      } else if (diffY < 0) {
        // Scroll down
        scrollDirection = 'down';
      } else if (diffY > 0) {
        // Scroll up
        scrollDirection = 'up';
      }
      scrollX = window.pageXOffset;
      scrollY = window.pageYOffset;
    }

    $('.delivery-time, .policy-tab').click(function() {
      $('.drawer1-content').html($(this).find('[drawer-content]').html())
      $('.drawer1').addClass('open');
      $('body').addClass('drawer--is-open');
    });

    $('.xactivity-top').click(function() {
      var drawerContent = $(this).closest('.xactivity').find('[drawer-content]')
      if (!drawerContent.length) {
        return
      }
      $('.drawer1-content').html(drawerContent.html())
      $('.drawer1').addClass('open');
      $('body').addClass('drawer--is-open');
    })
  
    $('.drawer1-mask, .drawer1-close').click(function() {
      $('.drawer1').removeClass('open');
      $('body').removeClass('drawer--is-open');
    });
  
  
   
    window.addEventListener('scroll', function() {
      const h_anchor = $('.product__anchor-points').height();
      getScrollAction();
      if (['left', 'right'].indexOf(scrollDirection) > -1) {
        return
      }
      const h_header = $('header.shopify-section-group-header-group').height();
      const fixedHeight = $('#details-purchase').offset().top
      if (scrollY >= fixedHeight - h_anchor) {
        if (scrollDirection  == 'up') {
          $('.product__anchor-points').css({
            'top': h_header,
            'display': 'block',
            'position': 'fixed'
          });
        }else{
          $('.product__anchor-points').css({
            'top': 0,
            'position': 'fixed',
            'display': 'block',
          });
        }
      } else {
        $('.product__anchor-points').css({
          'display': 'none',
        });
      }
    })

    if ($('add-button-scrolling').length) {
      window.addEventListener('scroll', function() {
        if ($(document).scrollTop() >= $('add-button-scrolling').offset().top - $(window).height() / 2) {
          var validOffset = $('.chooser-sticky').offset().top - $(window).scrollTop() - ($(window).height() - $('.chooser-sticky > form').height())
          if (validOffset > 0) {
            $('.chooser-sticky').addClass('chooser-sticky-active');
          } else {
            $('.chooser-sticky').removeClass('chooser-sticky-active');
          }
        } else {
          $('.chooser-sticky').removeClass('chooser-sticky-active');
        }
      })
    }

   
    $('#open-discount-drawer').click(function() {
        $('#discount-drawer').css('display', 'block');
        $('.drawer-content-copy').html($(this).find('[drawer-content]').html());
        $('body').css('overflow', 'hidden');
    });

    $('.discount-drawer-close , #discount-drawer').click(function() {
        $('#discount-drawer').css('display', 'none');
         $('body').css('overflow', '');
    });

    $('.discount-drawer-modal-content').click(function(event) {
        event.stopPropagation();
    });

});